import React, { createContext, useState, useEffect } from 'react';

const FormContext = createContext();

export const FormProvider = ({ children }) => {
    const [formData, setFormData] = useState(() => {
        const cachedData = localStorage.getItem('formData');
        return cachedData ? JSON.parse(cachedData) : {};
    });

    const updateFormData = (newData) => {
        setFormData((prevData) => {
            // Exclude specific keys from being cached
            const excludedKeys = ["pageView", "isRegEligible"];

            const updatedData = { ...prevData, ...newData };
            const dataToCache = Object.keys(updatedData).reduce((acc, key) => {
                if (!excludedKeys.includes(key)) {
                    acc[key] = updatedData[key];
                }
                return acc;
            }, {});

            localStorage.setItem('formData', JSON.stringify(dataToCache)); // Cache in localStorage
            return updatedData;
        });
    };

    const clearFormData = () => {
        localStorage.removeItem('formData'); // Clear cached data
        localStorage.removeItem('SUBMIT'); 
        setFormData({});

        sessionStorage.removeItem('started');
        sessionStorage.removeItem('codeSent');
        sessionStorage.removeItem('timer');
        // window.location.reload();
    };

    // Sync formData with localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('formData', JSON.stringify(formData));
    }, [formData]);

    return (
        <FormContext.Provider value={{ formData, updateFormData, clearFormData }}>
            {children}
        </FormContext.Provider>
    );
};

export default FormContext;